module.exports = __webpack_public_path__ + "img/dropdown1.d0d2038e.svg";